<template>
  <div class="section text-center">
    <div class="container">
      <h2 class="title">Témoignages</h2>
      <div class="w-100">
        <hooper :settings="hooperSettings" class="hopper mt-2 w-100 h-100">
          <slide class="team-player">
            <md-card class="md-card-plain">
              <div class="md-layout-item md-size-50 mx-auto">
                <img
                  :src="teamImg2"
                  alt="Thumbnail Image"
                  class="img-raised rounded-circle img-fluid"
                />
              </div>
              <h4 class="card-title">
                Christ Da-silva
                <br />
                <small class="card-description text-muted">{{
                  $t("landing.temoignage.fonction1")
                }}</small>
              </h4>

              <md-card-content>
                <p class="card-description">
                  {{ $t("landing.temoignage.temoin1") }}
                </p>
              </md-card-content>
            </md-card>
          </slide>



          <slide class="team-player">
            <md-card class="md-card-plain">
              <div class="md-layout-item md-size-50 mx-auto">
                <img
                  :src="teamImg3"
                  alt="Thumbnail Image"
                  class="img-raised rounded-circle img-fluid"
                />
              </div>
              <h4 class="card-title">
                Christelle Mounirou
                <br />
                <small class="card-description text-muted">{{
                  $t("landing.temoignage.fonction3")
                }}</small>
              </h4>

              <md-card-content>
                <p class="card-description">
                  {{ $t("landing.temoignage.temoin3") }}
                </p>
              </md-card-content>
            </md-card>
          </slide>

          <slide class="team-player">
            <md-card class="md-card-plain">
              <div class="md-layout-item md-size-50 mx-auto">
                <img
                  :src="header"
                  alt="Thumbnail Image"
                  class="img-raised rounded-circle img-fluid"
                />
              </div>
              <h4 class="card-title">
                Alim Guibe
                <br />
                <small class="card-description text-muted">{{
                  $t("landing.temoignage.fonction4")
                }}</small>
              </h4>

              <md-card-content>
                <p class="card-description">
                  {{ $t("landing.temoignage.temoin4") }}
                </p>
              </md-card-content>
            </md-card>
          </slide>

          <slide class="team-player">
            <md-card class="md-card-plain">
              <div class="md-layout-item md-size-50 mx-auto">
                <img
                  :src="teamImg4"
                  alt="Thumbnail Image"
                  class="img-raised rounded-circle img-fluid"
                />
              </div>
              <h4 class="card-title">
                Audrey Kiya
                <br />
                <small class="card-description text-muted">{{
                    $t("landing.temoignage.fonction5")
                  }}</small>
              </h4>

              <md-card-content>
                <p class="card-description">
                  {{ $t("landing.temoignage.temoin5") }}
                </p>
              </md-card-content>
            </md-card>
          </slide>

          <slide class="team-player">
            <md-card class="md-card-plain">
              <div class="md-layout-item md-size-50 mx-auto">
                <img
                  :src="teamImg5"
                  alt="Thumbnail Image"
                  class="img-raised rounded-circle img-fluid"
                />
              </div>
              <h4 class="card-title">
                Alim Guibe
                <br />
                <small class="card-description text-muted">{{
                    $t("landing.temoignage.fonction6")
                  }}</small>
              </h4>

              <md-card-content>
                <p class="card-description">
                  {{ $t("landing.temoignage.temoin6") }}
                </p>
              </md-card-content>
            </md-card>
          </slide>

          <slide class="team-player">
            <md-card class="md-card-plain">
              <div class="md-layout-item md-size-50 mx-auto">
                <img
                  :src="teamImg1"
                  alt="Thumbnail Image"
                  class="img-raised rounded-circle img-fluid"
                />
              </div>
              <h4 class="card-title">
                Cédric Tokponsi
                <br />
                <small class="card-description text-muted">
                  {{ $t("landing.temoignage.fonction2") }}
                </small>
              </h4>

              <md-card-content>
                <p class="card-description">
                  {{ $t("landing.temoignage.temoin2") }}
                </p>
              </md-card-content>
            </md-card>
          </slide>

          <hooper-navigation slot="hooper-addons"></hooper-navigation>
        </hooper>
      </div>
    </div>
  </div>
</template>

<script>
import { Hooper, Slide, Navigation as HooperNavigation } from "hooper";
import "hooper/dist/hooper.css";
export default {
  bodyClass: "landing-page",
  components: {
    Hooper,
    Slide,
    HooperNavigation
  },
  props: {
    header: {
      type: String,
      default: require("@/assets/img/faces/fakke2.jpeg")
    },
    teamImg1: {
      type: String,
      default: require("@/assets/img/faces/dgf.jpg")
    },
    teamImg2: {
      type: String,
      default: require("@/assets/img/faces/entre.jpeg")
    },
    teamImg3: {
      type: String,
      default: require("@/assets/img/faces/grose.webp")
    },
    teamImg4: {
      type: String,
      default: require("@/assets/img/faces/mom.png")
    },
    teamImg5: {
      type: String,
      default: require("@/assets/img/faces/cost.jpeg")
    }
  },
  data() {
    return {
      hooperSettings: {
        infiniteScroll: false,
        centerMode: false,
        autoPlay: true,
        playSpeed: 10000,
        breakpoints: {
          2400: {
            itemsToShow: 10
          },
          1800: {
            itemsToShow: 9
          },
          1500: {
            itemsToShow: 8
          },
          1100: {
            itemsToShow: 3.5
          },
          1024: {
            itemsToShow: 3.5
          },
          630: {
            itemsToShow: 3
          },
          504: {
            itemsToShow: 2
          },
          330: {
            itemsToShow: 1.5
          },
          0: {
            itemsToShow: 2
          }
        }
      }
    };
  }
};
</script>

<style lang="scss" scoped>
.md-card-actions.text-center {
  display: flex;
  justify-content: center !important;
}
.contact-form {
  margin-top: 30px;
}

.md-has-textarea + .md-layout {
  margin-top: 15px;
}
.hooper {
  height: auto;
}
.img-raised{
  width: 8rem;
  height: 8rem;
}
</style>
